import { Navigation } from '../../Components/Admin/Document/Navigation.js';
import { Header } from '../../Components/Admin/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { FormInsert } from '../../Components/Admin/Form/FormInsert.js';
import { AutoComplete } from '../../Components/Admin/Functions/AutoComplete.js';

export const Insert = (props) => {
    const token = sessionStorage.getItem('token');
    const { entity } = props;
    if (token) {
        return (
            <div className="insert">
                <Navigation entity={entity} />
                <Header />
                <FormInsert entity={entity} />
                <BackTop />
                <Footer />
                <script>{AutoComplete()}</script>
            </div>
        )
    } else {
        return (<></>)
    }
}